import {isEmpty, omitBy} from 'lodash'

import {getCleanSearch} from './window-location'

export const paramsFromLocation = () => Object.fromEntries(new URLSearchParams(getCleanSearch()))
export const addQuery = (url: string, query: Record<string, unknown> = {}) => {
  const [base, existingQuery] = url.split('?')
  const merged = {
    ...Object.fromEntries(new URLSearchParams(existingQuery || '')),
    ...omitBy(query, a => !a && a !== 0),
  }
  const newQuery = new URLSearchParams(merged as Record<string, string>).toString()
  return [base, newQuery].filter(a => !isEmpty(a)).join('?')
}

export const ensureURLProtocol = (url: string) => (/^https?:\/\/.*/.test(url) ? url : `https://${url}`)

function addPath(url: URL, path: string): URL
/** @deprecated use `new URL(url: string, base?: string))` instead */
function addPath(url: string, path: string): URL
function addPath(url: string | URL, path: string): URL {
  const oUrl = url instanceof URL ? url : new URL(url)
  oUrl.pathname = (oUrl.pathname + '/' + path).replace(/\/\/+/g, '/')

  return oUrl
}

export {addPath}
